"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeforeSendTask = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var BeforeSendTask = /** @class */ (function () {
    function BeforeSendTask() {
    }
    BeforeSendTask.prototype.execute = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var current, config;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.routeStackService.getCurrent()];
                    case 1:
                        current = _a.sent();
                        config = this.sdkConfigService.get();
                        context.list = context.list
                            .map(function (data) {
                            return _this.transform(config, data, current);
                        })
                            .filter(function (v) { return v; });
                        return [2 /*return*/];
                }
            });
        });
    };
    BeforeSendTask.prototype.transform = function (config, data, route) {
        var _a;
        var _b;
        var _c = this.pageConfigService.get() || {}, disableVisibilityHandler = _c.disableVisibilityHandler, restPageConfig = __rest(_c, ["disableVisibilityHandler"]);
        var sessionKey = this.sdkConfigService.get().sessionIdKey || "session_id";
        var needMasking = data.needMasking, inputKey = data.inputKey, event = data.event, rest = __rest(data, ["needMasking", "inputKey", "event"]);
        var record = __assign(__assign(__assign(__assign({ uri: (route === null || route === void 0 ? void 0 : route.uri) || "", screen_order: (route === null || route === void 0 ? void 0 : route.screenOrder) || 1, screen_referrer_num: "".concat((route === null || route === void 0 ? void 0 : route.screenReferrerNum) || -1), screen_referrer: (route === null || route === void 0 ? void 0 : route.screenReferrer) || "", screen_referrer_order: (route === null || route === void 0 ? void 0 : route.screenReferrerOrder) || 0 }, restPageConfig), { page_name: restPageConfig.page_name || "" }), rest), (_a = { page_id: "".concat(rest.page_id || restPageConfig.page_id || ""), $app_version: config.appVersion || "", app_name: config.appName || "", old_device_id: config.deviceId || "", self_uid: config.userId || "", adjust_id: config.adjustId || "", google_ad_id: config.googleAdId || "", device_uuid: config.deviceUuid || "" }, _a[sessionKey] = this.sessionService.get() || "", _a));
        switch (data.eventType) {
            case types_1.EventType.View:
                record = __assign(__assign({}, record), { 
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    Page_stayTime: data.duration || 0 });
                break;
            case types_1.EventType.Click:
            case types_1.EventType.PopClick:
                record = __assign(__assign({}, record), { element_id: "".concat(data.element_id || ""), element_name: data.element_name || "", business_type: "".concat(data.business_type || 0), pop_id: "".concat(data.pop_id || ""), pop_name: data.pop_name || "" });
                break;
            case types_1.EventType.PopView:
            case types_1.EventType.Expose:
                record = __assign(__assign({}, record), { element_id: "".concat(data.element_id || ""), element_name: data.element_name || "", business_type: "".concat(data.business_type || 0), duration: record.duration || 0, pop_id: "".concat(data.pop_id || ""), pop_name: data.pop_name || "" });
                break;
            case types_1.EventType.Input:
                record = __assign(__assign({}, record), { element_id: "".concat(data.element_id || ""), element_name: data.element_name || "", input_type: data.input_type || "End", input_value: this.mayMaskingInputContent(data, needMasking), input_is_copy: (_b = data.input_is_copy) !== null && _b !== void 0 ? _b : false });
                break;
            default:
                break;
        }
        return record;
    };
    BeforeSendTask.prototype.mayMaskingInputContent = function (data, needMasking) {
        var content = data.input_value;
        if (needMasking) {
            return (0, event_tracking_core_1.contentMasking)(content);
        }
        return content;
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IRouteStackService),
        __metadata("design:type", Object)
    ], BeforeSendTask.prototype, "routeStackService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.ISessionService),
        __metadata("design:type", Object)
    ], BeforeSendTask.prototype, "sessionService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.SDKConfigService),
        __metadata("design:type", Object)
    ], BeforeSendTask.prototype, "sdkConfigService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService),
        (0, inversify_1.named)(types_1.TAG.PageConfigService),
        __metadata("design:type", Object)
    ], BeforeSendTask.prototype, "pageConfigService", void 0);
    BeforeSendTask = __decorate([
        (0, inversify_1.injectable)()
    ], BeforeSendTask);
    return BeforeSendTask;
}());
exports.BeforeSendTask = BeforeSendTask;
